import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Layout, PageHeader, Tabs } from 'antd';
import { RETURN_TO_HOME } from './constants';
import { ConfigNav } from './styled';
import { hasAttributeValue, hasResourceOperation } from '../../../util/index';
import {
  ITEM_OPERATIONS,
  TM_FRAUD_SOURCE_IDS
} from '../../../util/GlobalConstant';
import { getSelectedResources } from '../../../util/resourceManager';
import Detection from './Detection';
import Prevention from './Prevention';

const { TabPane } = Tabs;

const ConfigureRunInstance = ({ history, location, authentication }) => {
  const { trmResources } = getSelectedResources();

  const returnToRunInstance = () => {
    history.push(RETURN_TO_HOME);
  };

  const query = new URLSearchParams(location.search);

  return (
    <Layout className="layout">
      <PageHeader
        ghost={false}
        onBack={returnToRunInstance}
        title="Run Instance"></PageHeader>
      <ConfigNav>
        <Tabs defaultActiveKey={`${query?.get('tab')}` || '1'}>
          {(hasAttributeValue(
            authentication,
            trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
            TM_FRAUD_SOURCE_IDS.TM
          ) && (
            <TabPane tab="Detection" key="1">
              <Detection />
            </TabPane>
          )) ||
            (hasAttributeValue(
              authentication,
              trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
              TM_FRAUD_SOURCE_IDS.FRAUD
            ) && (
              <TabPane tab="Detection" key="1">
                <Detection />
              </TabPane>
            ))}

          {hasAttributeValue(
            authentication,
            trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
            '24'
          ) && (
            <TabPane tab="Prevention" key="2">
              <Prevention />
            </TabPane>
          )}
        </Tabs>
      </ConfigNav>
    </Layout>
  );
};

ConfigureRunInstance.propTypes = { history: PropTypes.object };

export default withRouter(ConfigureRunInstance);
